import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { OfferStack } from './components/OfferStack';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel } from './lib/pixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-light font-sans text-brand-dark selection:bg-brand-accent selection:text-white" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=3437889759707218&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <UrgencyBar data-id="element-3" />
      <main data-id="element-4">
        <Hero data-id="element-5" />
        <HookSection data-id="element-6" />
        <PainSection data-id="element-7" />
        <RevelationSection data-id="element-8" />
        <OfferStack data-id="element-9" />
        <Testimonials data-id="element-10" />
        <FAQ data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}